module.exports = __webpack_public_path__ + "static/tactics_collection_tennis-ba21ea11cfb087b46b5a198308322823.mp4";